export class parametriDichiarazioni {
	adeguatezza: boolean | null;
	checkPolizza: boolean | null;
	checkPrivacy: boolean | null;
}